
<div class="flex brick" #brick>
  <div class="keyValue flex center-v" *ngIf="!structure.boolean; else templateBoolean">
    <w-slot>
      <w-select-one [(ngModel)]="structure.key" label="{{ 'general_words.type' | translate }}" [options]="general_words" (ngModelChange)="onSelectChange($event)"></w-select-one>
    </w-slot>
    <w-slot *ngIf="strategies.length">
      <w-select-one [(ngModel)]="structure.strategy" label="{{ 'page_similarname.refine_by' | translate }}" [options]="strategies_select" (ngModelChange)="onSelectChange($event)"></w-select-one>
    </w-slot>
    <w-slot class="bigger" [ngSwitch]="structure.key">
      <div class="inline-selector statuses flex center-v" *ngSwitchCase="'status'">
        <label class="flex center-v" *ngFor="let s of status" title="{{ ('tooltips.status_' + tooltipKey(s.value?.toLowerCase())) | translate }}" name="statuses">
          <input type="checkbox" (click)="onCheckboxChecked($event)" [value]="s.value" [(ngModel)]="status_value[s.value]"><span class="nobreak">{{ s.label }}</span>
        </label>
      </div>
      <div class="inline-selector type flex center-v" *ngSwitchCase="'type'">
        <label class="flex center-v" *ngFor="let t of type" name="types">
          <input type="checkbox" (click)="onCheckboxChecked($event)" [value]="t.value" [ngModel]="isChecked(t.value)"><span class="nobreak">{{ t.label }}</span>
        </label>
      </div>
      <div class="inline-selector type flex center-v wrap" *ngSwitchCase="'markFeature'">
        <label class="flex center-v" *ngFor="let f of markFeature" name="features" title="{{('tooltips.'+ tooltipKey(f.value)) | translate}}">
          <input type="checkbox" (click)="onCheckboxChecked($event)" [value]="f.value" [ngModel]="isChecked(f.value)"><span class="nobreak">{{ f.label }}</span>
        </label>
      </div>
      <ng-container *ngSwitchCase="'viennaClass'">
        <ng-container *ngTemplateOutlet="templateSuggestMultiselect"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'usDesignClass'">
        <ng-container *ngTemplateOutlet="templateSuggestMultiselect"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'niceClass'">
        <ng-container *ngTemplateOutlet="templateSuggestMultiselect"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'designation'">
        <ng-container *ngTemplateOutlet="templateSuggestMultiselect"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'office'">
        <ng-container *ngTemplateOutlet="templateSuggestMultiselect"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'applicant_cc'">
        <ng-container *ngTemplateOutlet="templateSuggestMultiselect"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'refOffice'">
        <ng-container *ngTemplateOutlet="templateSuggestMultiselect"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'appDate'">
        <ng-container *ngTemplateOutlet="templateDateSelector"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'regDate'">
        <ng-container *ngTemplateOutlet="templateDateSelector"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'expDate'">
        <ng-container *ngTemplateOutlet="templateDateSelector"></ng-container>
      </ng-container>
      <ng-container *ngSwitchCase="'termDate'">
        <ng-container *ngTemplateOutlet="templateDateSelector"></ng-container>
      </ng-container>
      <div class="flex column" *ngSwitchDefault>
        <w-input-text label="{{ strategyName | translate}}" [(ngModel)]="structure.value" (keyup)="onKey($event)" (ngModelChange)="onModelChange($event)"></w-input-text>
        <div class="solrHint" *ngIf="structure.strategy==='Solr'">Ex: wip* , w?po , world AND (intell* OR property) ...</div>
      </div>
      <div class="floatingButtons">
        <button class="nobreak flex center-v" w-button [isDefault]="true" (click)="emitBooleanize()"><span>{{ 'page_advanced_search.convert_to_and_or' | translate}}</span></button>
        <button class="deleteRow" w-button (click)="emitDelete()"><span class="b-icon b-icon--trash red"></span></button>
      </div>
    </w-slot>
  </div>
</div>
<ng-template #templateSuggestMultiselect>
  <suggest-multiselect class="flex" [(ngModel)]="structure.value" [what]="structure.key"></suggest-multiselect>
</ng-template>
<ng-template #templateBoolean>
  <div class="booleanAndArc flex center-v" *ngIf="structure.bricks.length > 1">
    <select class="uppercase" [(ngModel)]="structure.boolean">
      <option class="uppercase" value="AND">{{ 'general_words.AND' | translate}}</option>
      <option class="uppercase" value="OR">{{ 'general_words.OR' | translate}}</option>
    </select>
    <div class="c-arc" [ngStyle]="{height : getAndOrHeight(0)}">
      <div class="arc"></div>
    </div>
  </div>
  <div class="flex column grow nextLevel">
    <ng-container *ngIf="structure.bricks">
      <brick *ngFor="let structure_chid of structure.bricks; let i = index" [class.active]="ms.activeBrickId===structure_chid._id" [parent]="structure" [style.zIndex]="50-i" (click)="ms.activeBrickId=structure_chid._id" [structure]="structure_chid" (actionEvent)="actionHandler($event)" [level]="level+1"></brick>
    </ng-container>
    <div class="addButtons">
      <button class="nobreak" w-button [isDefault]="true" (click)="addBoolean()">+ ADD A ROW</button>
    </div>
  </div>
</ng-template>
<ng-template #templateDateSelector>
  <div class="dateSelector flex column">
    <div class="top flex center-v">
      <ng-container *ngIf="structure.strategy==='Range'; else singleDateSelector"><span class="word">from</span>
        <w-input-date [value]="structure.value[0]" [placeholder]="structure.value[0] || datesFormatsMapping[ps.preferences.all.dateFormat]" [dateFormat]="ps.preferences.all.dateFormat" yearRange="1800:2100" (wDateSelect)="onDateSelected($event,0)" (input)="onDateTextInput($event,0)" (blur)="onDateTextInput($event,0)"></w-input-date><span class="word">to</span>
        <w-input-date [value]="structure.value[1]" [placeholder]="structure.value [1] || datesFormatsMapping[ps.preferences.all.dateFormat]" [dateFormat]="ps.preferences.all.dateFormat" yearRange="1800:2100" (wDateSelect)="onDateSelected($event,1)" (input)="onDateTextInput($event,1)" (blur)="onDateTextInput($event,1)"></w-input-date>
      </ng-container>
      <ng-template #singleDateSelector>
        <w-input-date [value]="structure.value" [placeholder]="structure.value || datesFormatsMapping[ps.preferences.all.dateFormat]" [dateFormat]="ps.preferences.all.dateFormat" yearRange="1800:2100" (wDateSelect)="onDateSelected($event)" (input)="onDateTextInput($event)" (blur)="onDateTextInput($event)"></w-input-date>
      </ng-template>
    </div>
    <div class="dateFormatSelector flex center-v">
      <label class="nobreak">
        <input type="radio" [name]="'dateFormat'+this.structure._id" [ngModel]="ps.preferences.all.dateFormat" (click)="onDateFormatChange($event)" value="yy-mm-dd"><span class="nobreak">ISO8601 (YYYY-MM-DD)</span>
      </label>
      <label class="nobreak">
        <input type="radio" [name]="'dateFormat'+this.structure._id" [ngModel]="ps.preferences.all.dateFormat" (click)="onDateFormatChange($event)" value="dd/mm/yy"><span class="nobreak">European (DD/MM/YYYY)</span>
      </label>
      <label class="nobreak">
        <input type="radio" [name]="'dateFormat'+this.structure._id" [ngModel]="ps.preferences.all.dateFormat" (click)="onDateFormatChange($event)" value="mm/dd/yy"><span class="nobreak">American (MM/DD/YYYY)</span>
      </label>
    </div>
  </div>
</ng-template>
